/*
 * Tailwind Font Size Settings
 */

import settings from './tailwind.settings'

const fsMin = settings.typography.fontSizeMin
const fsMax = settings.typography.fontSizeMax
const msFactorMin = settings.typography.msFactorMin
const msFactorMax = settings.typography.msFactorMax
const screenMin = settings.screensRem.min
const screenMax = settings.screensRem['2xl']

// Calc Min and Max Fontsize
const calcMulti = (multiMin = 0, multiMax = null) => {
    return {
        fsMin: fsMin * Math.pow(msFactorMin, multiMin),
        fsMax: fsMax * Math.pow(msFactorMax, multiMax || multiMin),
    }
}

// build the clamp property
const clamp = (multiMin = 0, multiMax = null) => {
    const _calcMulti = calcMulti(multiMin, multiMax || multiMin)
    const _fsMin = _calcMulti.fsMin
    const _fsMax = _calcMulti.fsMax
    return `clamp(${_fsMin}rem, calc(${_fsMin}rem + (${_fsMax} - ${_fsMin}) * ((100vw - ${screenMin}rem) / (${screenMax} - ${screenMin}))), ${_fsMax}rem)`
}

export default {
    xxxs: clamp(-3.5),
    xxs: clamp(-3.0),
    xs: clamp(-2.0),
    sm: clamp(-1.5),
    base: clamp(-1.0),
    content: [clamp(-0.5), '2rem'],
    lg: clamp(0.5),
    xl: clamp(1.0),
    '2xl': clamp(1.5),
    '3xl': clamp(2.5),
    '4xl': clamp(3.5),
    '5xl': clamp(4.5),
    '6xl': clamp(5.5),
    '7xl': clamp(6.5),
    '8xl': clamp(7.5),
    '9xl': clamp(8.5),
}
